<div class="custom-modal-layout">
  <div class="modal-header">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Seleção de Áreas de Formação" />
    </div>
    <span class="title">Selecionar Áreas de Formação</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancelar()"></p-button>
  </div>
  <form [formGroup]="areasFormacaoForm" (ngSubmit)="confirmarSelecao()">
    <div class="p-fluid grid">
      <div class="field col-12">
        <label for="areasFormacao">Áreas de Formação</label>
        <p-multiSelect
          id="areasFormacao"
          formControlName="selectedAreas"
          [options]="areasFormacao"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          class="w-full"
          placeholder="Selecione as áreas de formação"
        ></p-multiSelect>
      </div>
    </div>
    <div class="modal-footer">
      <p-button class="p-button-outlined" label="Cancelar" (click)="cancelar()"></p-button>
      <p-button type="submit" label="Confirmar" class="p-button-primary" [disabled]="!areasFormacaoForm.valid"></p-button>
    </div>
  </form>
</div>
<p-toast></p-toast>
